import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
//import { useParams } from 'react-router-dom';
import React from 'react';
import { useHistory } from 'react-router';
//import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const TopLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const { name } = props;
  //const s = useParams();
  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');

  const h = useHistory();
  const goBack = () => {
    h.push(`/storeVoucherList`);
  };

  const b = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/storeVoucherList`,
      name: getI18n('voucher.storeVoucherDetail.storeVoucher'),
    },
    {
      url: ``,
      name: getI18n('voucher.storeVoucherDetail.voucherEdit'),
    },
    // {
    //   url: ``,
    //   name: name,
    // },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={b} />;
};
export default TopLeft;
